import * as React from 'react';
import { IMicrositeRecipientCoachLogEntry } from '@nkr/models/index';
import { Button, FormControl, Label } from 'react-bootstrap';
import { Icon } from 'react-icons-kit';
import { pushpin } from 'react-icons-kit/icomoon/pushpin';
import { edit } from 'react-icons-kit/fa/edit';
import { trashO } from 'react-icons-kit/fa/trashO';
import * as moment from 'moment';
import { ActionType } from '@nkr/enums/coach-log-action-type';
import { IApplicationState, IAppState } from '@nkr/store/index';
import { connect, Dispatch } from 'react-redux';

interface IProps {
    data: IMicrositeRecipientCoachLogEntry,
    onEdit: (id: number) => void,
    onConfirmDelete: (id: number) => void
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {}

type TProps = IProps & IStateProps & IDispatchProps;

const LogEntry: React.FunctionComponent<TProps> = (props) => {
    const handleEdit = () => {
        props.onEdit(props.data.id);
    }

    const handleConfirmDelete = () => {
        props.onConfirmDelete(props.data.id);
    }

    const getActionType = (actionType: ActionType) => {
        switch(actionType)
        {
            case ActionType.CALLED:
                return "Called";
            case ActionType.LEFT_VOICEMAIL:
                return "Left Voicemail";
            case ActionType.EMAILED:
                return "Emailed";
            case ActionType.TEXTED:
                return "Texted";
            case ActionType.OTHER:
                return "Other";
            default:
                return "";
        }
    }

    const canEditAndDelete = props.data.createdByUserId == null 
        || props.data.createdByUserId == undefined 
        || props.app.user?.id == props.data.createdByUserId;
    
    const editTip = canEditAndDelete ? 'Edit this entry' : 'Entry cannot be edited because it was created by another user.';
    const deleteTip = canEditAndDelete ? 'Delete this entry' : 'Entry cannot be deleted because it was created by another user.';
    
    return (
        <div className={props.data.isPinned ? 'alert alert-info' : 'well well-default'} style={{ marginBottom: 10, position: 'relative' }}>
            {props.data.isPinned && (
                <div style={{ position: 'absolute', top: -7, right: -7 }} title='This entry is pinned and will stay near the top of the list'>
                    <Icon icon={pushpin} />
                </div>
            )}

            <div>
                <div><Label bsStyle='info'>{moment(props.data.updatedDateTime).isValid() ? moment(props.data.updatedDateTime).format("MM-DD-YYYY h:mm a") : moment(props.data.logDateTime).format("MM-DD-YYYY h:mm a")  }</Label></div>
                <div><Label bsStyle='primary'>{props.data.actionType >= 0 ? getActionType(props.data.actionType) : ''}</Label></div>
                <div style={{marginTop: '10px'}}><FormControl componentClass="textarea" style={{resize: 'none', height: '100px'}}value={props.data.content} disabled/></div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Button bsStyle='link' style={{ padding: '2px 0px 0px 0px', marginRight: 5 }} disabled={!canEditAndDelete} title={editTip} onClick={handleEdit}><Icon icon={edit} size={24} /></Button>
                <Button bsStyle='link' style={{ padding: 0 }} disabled={!canEditAndDelete} title={deleteTip} onClick={handleConfirmDelete}><Icon icon={trashO} size={24} /></Button>
            </div>
        </div>
    );
}


const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {};
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(LogEntry);
    